// Shopify Forms renders inside a shadow root. Keep presentation local to this
// section; the app remains responsible for fields, consent and submissions.
if (!customElements.get('giveaway-form')) {
  customElements.define('giveaway-form', class extends HTMLElement {
    connectedCallback() {
      let attempts = 0;
      const attachStyles = () => {
        const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
        if (root?.querySelector('[data-current-step]')) {
          if (!root.querySelector('[data-giveaway-styles]')) {
            const stylesheet = document.createElement('link');
            stylesheet.rel = 'stylesheet';
            stylesheet.href = this.dataset.styles;
            stylesheet.dataset.giveawayStyles = '';
            root.appendChild(stylesheet);
          }
          return;
        }
        if (this.isConnected && ++attempts < 120) {
          this.styleTimer = setTimeout(attachStyles, 250);
        }
      };
      attachStyles();
    }
    disconnectedCallback() {
      clearTimeout(this.styleTimer);
    }
  });
}
